import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useStore } from "react-redux";
import useConnectivityReporter from "src/hooks/useConnectivityReporter";
import useConnectivityQualityReporter from "src/hooks/useConnectivityQualityReporter";
import useApiMonitorPersist from "src/hooks/useApiMonitorPersist";
import useApiMonitorRemoteToggle from "src/hooks/useApiMonitorRemoteToggle";
import { addHubErrors } from "src/redux/slices/errors";
import { installDebugInstrumentation, trackRoute } from "src/utils/debug/debugEvents";
import { sourceForPath } from "src/utils/debug/debugScreen";

// Fase 5 · Instrumentación de depuración montada UNA vez a nivel de App
// (dentro del Router). Antes los hooks del monitor vivían solo en el
// DashboardLayout con `source: "manage-admin"` fijo: el TPV camarero
// (TpvCartaLayout / rutas sin layout) nunca recibía el toggle remoto ni
// persistía nada. Aquí cubren todas las rutas /app con el `source` real
// ("tpv-grid", "tpv-carta", "kds", "admin") y sin montajes dobles.

function MonitorHooks({ source }) {
  useConnectivityReporter({ source });
  useConnectivityQualityReporter({ source });
  useApiMonitorPersist({ source });
  useApiMonitorRemoteToggle();
  return null;
}

export default function DebugInstrumentation() {
  const location = useLocation();
  const dispatch = useDispatch();
  const store = useStore();

  useEffect(() => {
    installDebugInstrumentation({
      dispatchHubError: (row) => dispatch(addHubErrors(row)),
      isMonitoringOn: () => !!store.getState()?.errors?.isMonitoring,
    });
  }, [dispatch, store]);

  useEffect(() => {
    trackRoute(location.pathname);
  }, [location.pathname]);

  const source = sourceForPath(location.pathname);
  // Rutas públicas (carta QR del cliente, reservas…): sin monitor.
  if (!source) return null;
  return <MonitorHooks source={source} />;
}
